(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue"), require("vue-router"), require("vant"));
	else if(typeof define === 'function' && define.amd)
		define(["vue", "vue-router", "vant"], factory);
	else if(typeof exports === 'object')
		exports["h5Lib"] = factory(require("vue"), require("vue-router"), require("vant"));
	else
		root["h5Lib"] = factory(root["Vue"], root["Vue-router"], root["vant"]);
})(self, function(__WEBPACK_EXTERNAL_MODULE__6197__, __WEBPACK_EXTERNAL_MODULE__5012__, __WEBPACK_EXTERNAL_MODULE__551__) {
return 